import React, { useEffect } from "react";
import AnimatedPage from "./AnimatedPage";
import { useState } from "react";
import axios from "axios";
import GridLoader from "react-spinners/GridLoader";

function ViewTopics({ isAuthenticated }) {
  const [year, setYear] = useState("select");
  const [uploadsInYears, setUploadsInYears] = useState([]);
  const [cumUploadsInYears, setCumUploadsInYears] = useState([]);
  const [yearData, setYearData] = useState([]);
  const [cumYearData, setCumYearData] = useState([]);
  const [month, setMonth] = useState("select");
  const years = [2023, 2024, 2025, 2026, 2027];
  const [date, setDate] = useState();
  const [daysData, setDaysData] = useState([]);
  const [cumDaysData, setCumDaysData] = useState([]);
  const [yearLoading, setYearLoading] = useState(false);
  const [monthLoading, setMonthLoading] = useState(false);
  const [dayLoading, setDayLoading] = useState(false);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    async function fetchData() {
      setYearLoading(true);
      let body = { years: years };
      const res = await axios.post(
        "https://api.hemenparekh.ai/dashboard/get_topics_count/",
        body
      );
      let newArr = Array(years.length).fill(0);
      newArr[0] = res.data[0];
      for (let i = 1; i < years.length; i++) {
        newArr[i] = newArr[i - 1] + res.data[i];
      }
      setUploadsInYears(res.data);
      setCumUploadsInYears(newArr);
      setYearLoading(false);
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function getDaysData(year, month, daysInMonth) {
      setDayLoading(true);
      const body = { year: year, month: month, daysInMonth: daysInMonth };
      const res = await axios.post(
        "https://api.hemenparekh.ai/dashboard/get_topics_count_by_day/",
        body
      );
      let newArr = Array(daysInMonth).fill(0);
      newArr[0] = res.data.dailyCount[0] + res.data.beforeGivenMonth;
      for (let i = 1; i < daysInMonth; i++) {
        newArr[i] = newArr[i - 1] + res.data.dailyCount[i];
      }
      setDaysData(res.data.dailyCount);
      setCumDaysData(newArr);
      setDayLoading(false);
    }
    if (month === "2") {
      if (year % 4 === 0) {
        setDate(29);
        getDaysData(year, month, 29);
      } else {
        setDate(28);
        getDaysData(year, month, 28);
      }
    } else if (
      month === "4" ||
      month === "6" ||
      month === "9" ||
      month === "11"
    ) {
      setDate(30);
      getDaysData(year, month, 30);
    } else {
      setDate(31);
      getDaysData(year, month, 31);
    }
  }, [month, year]);

  useEffect(() => {
    async function fetchData() {
      setMonthLoading(true);
      const res = await axios.get(
        `https://api.hemenparekh.ai/dashboard/get_topics_count_by_year/${year}`
      );
      let newArr = Array(12).fill(0);
      newArr[0] = res.data.monthlyCount[0] + res.data.beforeGivenYear;
      for (let i = 1; i < 12; i++) {
        newArr[i] = newArr[i - 1] + res.data.monthlyCount[i];
      }
      setCumYearData(newArr);
      setYearData(res.data.monthlyCount);
      setMonthLoading(false);
    }
    if (year !== "select") fetchData();
  }, [year]);

  return (
    isAuthenticated && (
      <AnimatedPage>
        <div className="main-container">
          <h1>View Topics</h1>
          <GridLoader
            color="red"
            loading={yearLoading}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
          {!yearLoading && (
            <>
              <table border="1px">
                <tr>
                  <th>Year</th>
                  <th>Uploaded during period</th>
                  <th>Cumulative Uploaded</th>
                </tr>
                {years.map((data, index) => (
                  <tr>
                    <td>{data}</td>
                    <td>{uploadsInYears[index]}</td>
                    <td>{cumUploadsInYears[index]}</td>
                  </tr>
                ))}
              </table>
              <br />
              <br />
              <p>Select an year: </p>
              <select
                onChange={(e) => {
                  setYear(e.target.value);
                  setMonth("select");
                }}
              >
                <option value="select">--select--</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
              </select>
              <GridLoader
                color="red"
                loading={monthLoading}
                size={10}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
              <br />
              {year !== "select" && !monthLoading && (
                <>
                  <table border="1px">
                    <tr>
                      <th>Month</th>
                      <th>Uploaded during period</th>
                      <th>Cumulative Uploaded</th>
                    </tr>
                    {yearData.map((data, index) => (
                      <tr>
                        <td>{months[index]}</td>
                        <td>{data}</td>
                        <td>{cumYearData[index]}</td>
                      </tr>
                    ))}
                  </table>
                  <br />
                  <br />
                  <p>Select a month: </p>
                  <select
                    onChange={(e) => {
                      setMonth(e.target.value);
                    }}
                  >
                    <option value="select">--select--</option>
                    <option value="01">January</option>
                    <option value="02">February</option>
                    <option value="03">March</option>
                    <option value="04">April</option>
                    <option value="05">May</option>
                    <option value="06">June</option>
                    <option value="07">July</option>
                    <option value="08">August</option>
                    <option value="09">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                  <GridLoader
                    color="red"
                    loading={dayLoading}
                    size={10}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                  <br />
                  {month !== "select" && !dayLoading && (
                    <table border="1px">
                      <tr>
                        <th>Date</th>
                        <th>Uploaded during period</th>
                        <th>Cumulative Uploaded</th>
                      </tr>
                      {Array.from({ length: date }, (_, i) => (
                        <tr>
                          <td>{i + 1}</td>
                          <td>{daysData[i]}</td>
                          <td>{cumDaysData[i]}</td>
                        </tr>
                      ))}
                    </table>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </AnimatedPage>
    )
  );
}

export default ViewTopics;
